export enum Translates {
	PLAN_NAME = 'PLAN_NAME',
	PLANOGRAM_NAME = 'PLANOGRAM_NAME',
	FACES_QTY = 'FACES_QTY',
	PRODUCT_STOCK_ON_SHELF_PSC = 'PRODUCT_STOCK_ON_SHELF_PSC',
	TYPE = 'SIMPLE_CHANGE',
	SOURCE = 'CHANGE_SOURCE',
	CREATED_AT = 'CHANGE_DATE',
	DELETE_PACKING = 'PRODUCT_CARD.DELETE_PACKING',
	CHANGE_PACKING = 'PACKING',
	NEW_PACKING = 'PACKING',
	CHANGE_PHOTO = 'PRODUCT_CARD.CHANGE_PHOTO',
	CHANGE_SIZES = 'SIZES',
	CHANGE_IS_LOOSE = 'TYPE_PRODUCT',
	COMPRESSION_COEF = 'PRODUCT_CARD.COMPRESSION_COEF',
	NEW_PRODUCT = 'PRODUCT_CARD.NEW_PRODUCT',
	ARTICLE_VALUE = 'ARTICLE',
	BARCODE_VALUE = 'BARCODE',
	NAME = 'PRODUCT_NAME',
	BRAND_NAME = 'BRAND',
	IS_LOOSE_VALUE = 'TYPE_PRODUCT',
	LOOSE = 'IS_LOOSE',
	PACKED = 'PACKED',
	LAST_CHANGE = 'LAST_CHANGE',
	CHANGE_PARAMS = 'PARAMETERS',
	PRODUCT_SHELTER = 'Listex',
	TRANSITION = 'Database/Connector',
	LAYOUT_PARAMS = 'LAYOUT_PARAMS',
	PLANOHERO = 'PlanoHero',
	PLAN_NAMES = 'PLAN_NAME',
	NUMBER = 'EQUIPMENT_NUMBER',
	CATEGORIES_VALUE = 'CATEGORY',
	LAID_PRODUCT_CATEGORIES = 'COMMON.PRODUCT.LAID_CATEGORIES',
	PLANOGRAM_CATEGORIES = 'COMMON.PLANOGRAM.CATEGORIES',
	BRANDS = 'BRAND',
	SHOP_NAME = 'SHOP_NAME',
	TRADE_AREA =  'TRADE_AREA',
	PLANOGRAMS_COUNT = 'PLANOGRAMS_LIST.QUANTITY',
	SHOP_FORMATS = 'FORMAT_NAME',
	SHOP_GROUP = 'SHOP_GROUP_NAME',
	EQUIPMENT_NAME = 'EQUIPMENT_NAME',
	TYPE_NAME = 'EQUIPMENT_TYPE',
	CODE = 'EQUIPMENT_CODE',
	PRODUCER = 'EQUIPMENT_PRODUCER',
	PLANS_COUNT = 'PLANS_LIST.QUANTITY',
	EQUIPMENT_IS_USED = 'EQUIPMENTS_LIST.USED_EQUIPMENT',
	EQUIPMENT_IS_NOT_USED = 'EQUIPMENTS_LIST.UNUSED_EQUIPMENT',
	NOT_ACTIVE_AND_IS_LAID = 'PRODUCT_CARD.NOT_ACTIVE_LAYOUT',
	IS_ACTIVE_AND_NOT_LAID = 'PRODUCT_CARD.ACTIVE_EMPTY_LAYOUT',
	IS_ACTIVE_AND_IS_LAID = 'PRODUCT_CARD.ACTIVE_HAS_LAYOUT',
	NOT_ACTIVE_AND_NOT_LAID = 'PRODUCT_CARD.NOT_ACTIVE',
	CATEGORY_PATH = 'CATEGORY',
	PLAN_IS_ACTIVE = 'ACTIVE_PLAN',
	PLAN_IS_NOT_ACTIVE = 'INACTIVE_PLAN',
	SUPPLIER_NAME = 'SUPPLIER',
	PRICE = 'PRICE',
	STOCK_QTY_DAYS = 'PRODUCT_STOCK_ON_SHELF_DAYS',
	STOCK_QTY = 'STOCK_QTY',
	SALES_QTY = 'QTY',
	AVG_PRICE_EXPLANATION = 'AVG_PRICE_EXPLANATION',
	SUM_STOCK_QTY_EXPLANATION = 'SUM_STOCK_QTY_EXPLANATION',
	NO_BRAND = 'NO_BRAND',
	STATUS = 'STATUS',
	SALES_QTY_LAST_90_DAYS_ZERO = 'PRODUCT_HOLES_ANALYTICS.SALES_QTY_LAST_90_DAYS_ZERO',
	ASSORTMENT_TYPE = 'ASSORTMENT_TYPE',
	PRODUCT_STATUS_TYPE = 'PRODUCT_STATUS_TYPE',
	WITHOUT_CATEGORY = 'WITHOUT_CATEGORY'
}

// TODO: translates